<template>
  <b-card class="border-0 shadow-sm rounded-lg overflow-hidden" no-body>
    <div class="bg-gradient-primary p-3 text-white d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <i class="fa fa-calculator mr-2"></i>
        <h5 class="mb-0 font-weight-bold">Resumo de Totais</h5>
      </div>
      <b-button variant="link" class="text-white p-0" @click="$emit('ver-detalhes')" title="Ver Detalhamento de Impostos">
        <i class="fa fa-external-link"></i>
      </b-button>
    </div>
    
    <b-list-group flush class="premium-list-group">
      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">Subtotal</span>
        <span class="font-weight-bold text-dark">{{ formatCurrency(subtotal) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">ICMS</span>
        <span class="font-weight-bold text-info">{{ formatCurrency(totalIcms) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light" >
        <span class="text-muted small font-weight-bold">IBS</span>
        <span class="font-weight-bold text-info">{{ formatCurrency(totalIbs) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light" >
        <span class="text-muted small font-weight-bold">CBS</span>
        <span class="font-weight-bold text-info">{{ formatCurrency(totalCbs) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light" >
        <span class="text-muted small font-weight-bold">Imposto Seletivo (IS)</span>
        <span class="font-weight-bold text-info">{{ formatCurrency(totalIs) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">IPI</span>
        <span class="font-weight-bold text-warning">{{ formatCurrency(totalIpi) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">PIS</span>
        <span class="font-weight-bold text-secondary">{{ formatCurrency(totalPis) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">COFINS</span>
        <span class="font-weight-bold text-secondary">{{ formatCurrency(totalCofins) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">Frete</span>
        <span class="font-weight-bold text-dark">{{ formatCurrency(frete) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">Seguro</span>
        <span class="font-weight-bold text-dark">{{ formatCurrency(seguro) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">Desconto</span>
        <span class="font-weight-bold text-danger">-{{ formatCurrency(desconto) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">Valor ICMS ST</span>
        <span class="font-weight-bold text-info">{{ formatCurrency(totalIcmsSt) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-2 border-light">
        <span class="text-muted small font-weight-bold">Crédito Presumido</span>
        <span class="font-weight-bold text-success">{{ formatCurrency(creditoPresumido) }}</span>
      </b-list-group-item>

      <b-list-group-item class="d-flex justify-content-between align-items-center py-3 bg-light">
        <span class="h6 mb-0 font-weight-bold text-primary">Total da Nota</span>
        <span class="h5 mb-0 font-weight-bold text-primary">{{ formatCurrency(totalNota) }}</span>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<style scoped>
.premium-list-group .list-group-item {
  border-left: 0;
  border-right: 0;
  transition: background-color 0.2s;
}
.premium-list-group .list-group-item:hover {
  background-color: rgba(0,0,0,0.02);
}
</style>

<script>
import Tools from '@/tools/tools.js'

export default {
  name: 'NfePainelTotais',
  props: {
    nfe: { type: Object, required: true }
  },
  computed: {
    subtotal() {
      return Number(this.nfe.VL_TOTAL_PRODUTOS || 0)
    },
    totalIcms() {
      return Number(this.nfe.VL_TOTAL_ICMS || 0)
    },
    totalIbs() {
      return Number(this.nfe.VIBSTOT || 0)
    },
    totalCbs() {
      return Number(this.nfe.VCBS_TOT || 0)
    },
    totalIs() {
      return Number(this.nfe.VISTOT || 0)
    },
    totalIpi() {
      return Number(this.nfe.VL_TOTAL_IPI || 0)
    },
    totalPis() {
      return Number(this.nfe.VL_TOTAL_PIS || 0)
    },
    totalCofins() {
      return Number(this.nfe.VL_TOTAL_COFINS || 0)
    },
    frete() {
      return Number(this.nfe.VL_TOTAL_FRETE || 0)
    },
    seguro() {
      return Number(this.nfe.VL_TOTAL_SEGURO || 0)
    },
    desconto() {
      return Number(this.nfe.VL_TOTAL_DESCONTO || 0)
    },
    totalIcmsSt() {
      return Number(this.nfe.VL_TOTAL_ST_ICMS || 0)
    },
    creditoPresumido() {
      return Number(this.nfe.VL_CREDITO_PRESUMIDO || 0)
    },
    totalNota() {
      // Backend retorna VL_TOTAL_NFE já calculado
      return Number(this.nfe.VL_TOTAL_NFE || 0)
    }
  },
  methods: {
    formatCurrency(v) {
      return Tools.formatCurrency(v)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfePainelTotais.vue